import { metricKeys } from '@pulse/metrics';

// Base Viewer Metrics
const VIEWERS_METRICS: any = {
  PLAY_GROUP: [
    metricKeys.Plays,
    metricKeys.Minutes,
  ],
  SPI: [
    metricKeys.StreamingPerformanceIndex,
  ],
  QUALITY_GROUP: [
    metricKeys.VideoStartTime,
    metricKeys.RebufferingRatio,
  ],
};

// Error Group Metrics if Business error metrics are disabled
const ERROR_GROUP = [
  metricKeys.VideoStartFailures,
  metricKeys.ExitBeforeVideoStarts,
  metricKeys.VideoPlaybackFailures,
];

// Error Group Metrics if Business error metrics are enabled
const BUSINESS_ERROR_GROUP = [
  metricKeys.VideoStartFailuresTech,
  metricKeys.VideoStartFailuresBusiness,
  metricKeys.ExitBeforeVideoStarts,
  metricKeys.VideoPlaybackFailuresTech,
  metricKeys.VideoPlaybackFailuresBusiness,
];

const GEO_DATA_METRICS = [
  metricKeys.PercentageComplete,
  metricKeys.VideoStartTime,
  metricKeys.RebufferingRatio,
  metricKeys.Bitrate,
  metricKeys.ConnectionInducedRebufferingRatio,
  metricKeys.VideoRestartTime,
];

const GEO_ERROR_METRICS = [
  metricKeys.VideoStartFailures,
  metricKeys.RebufferingRatio,
  metricKeys.Bitrate,
];
// Returns the metrics in the form of categories
const viewersMetricCategory = (isbusinessMetricsEnabled, isAdvancedMetrics = false) => {
  const metrics = JSON.parse(JSON.stringify(VIEWERS_METRICS));
  const ERROR_METRICS = isbusinessMetricsEnabled ? BUSINESS_ERROR_GROUP : ERROR_GROUP;
  metrics.ERROR_GROUP = ERROR_METRICS;
  /*
        Add these metrics if Advanced metrics are enabled
        ConnectionInducedRebufferingRatio and VideoRestartTime are enabled together from Portal using the
        Advanced metric radio button. So checking for either of them in the IF condition should be enough.
    */
  if (isAdvancedMetrics && !metrics.QUALITY_GROUP.includes(metricKeys.VideoRestartTime)) {
    metrics.QUALITY_GROUP.push(metricKeys.ConnectionInducedRebufferingRatio, metricKeys.VideoRestartTime);
  }
  metrics.QUALITY_GROUP.push(metricKeys.Bitrate);

  return metrics;
};

// Returns the array of metric names
const viewerMetricList = (isbusinessMetricsEnabled, isAdvancedMetrics) => {
  const viewerMetrics = viewersMetricCategory(isbusinessMetricsEnabled, isAdvancedMetrics);
  const metricList = [
    ...viewerMetrics.PLAY_GROUP,
    ...viewerMetrics.SPI,
    ...viewerMetrics.ERROR_GROUP,
    ...viewerMetrics.QUALITY_GROUP,
  ];
  return metricList;
};

export {
  viewersMetricCategory,
  viewerMetricList,
  GEO_DATA_METRICS,
  GEO_ERROR_METRICS,
};
